import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Garantia() {
  return (
    <LegalLayout
      testId="garantia-page"
      title="Garantia"
      intro="Transparência também na garantia. Entenda como funciona o cuidado com o seu aparelho após o serviço."
    >
      <Section heading="Cobertura">
        <p>
          Os serviços realizados pela Inove Tech contam com garantia sobre o
          reparo executado e as peças aplicadas, conforme informado no momento
          do atendimento.
        </p>
      </Section>

      <Section heading="O que a garantia cobre">
        <p>
          A garantia cobre eventuais falhas relacionadas diretamente ao serviço
          realizado. Antes de qualquer intervenção, você entende exatamente o
          que será feito.
        </p>
      </Section>

      <Section heading="O que não é coberto">
        <p>
          Não estão cobertos danos por mau uso, quedas, contato com líquidos
          após o serviço, ou intervenções realizadas por terceiros após o
          atendimento.
        </p>
      </Section>

      <Section heading="Dúvidas sobre garantia">
        <p>
          Ficou com alguma dúvida sobre o seu caso? Fale com a gente pelo
          WhatsApp e explicamos tudo com clareza.
        </p>
      </Section>
    </LegalLayout>
  );
}
